/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Sponsored_DescInputs */

const en_directory_home_sponsored_desc = /** @type {(inputs: Directory_Home_Sponsored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoted placements, clearly labeled — never mixed into editorial picks.`)
};

const zh_directory_home_sponsored_desc = /** @type {(inputs: Directory_Home_Sponsored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付费推广位，明确标注，绝不混入编辑精选。`)
};

/**
* | output |
* | --- |
* | "Promoted placements, clearly labeled — never mixed into editorial picks." |
*
* @param {Directory_Home_Sponsored_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_sponsored_desc = /** @type {((inputs?: Directory_Home_Sponsored_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Sponsored_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_sponsored_desc(inputs)
	return zh_directory_home_sponsored_desc(inputs)
});
export { directory_home_sponsored_desc as "directory.home.sponsored_desc" }